import clsx from 'clsx';
import { useEditorRef } from 'platejs/react';
import { useSelectionFragmentProp } from '@platejs/utils/react';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import { setAlign } from '@platejs/basic-styles';
import toolbarStyles from '../PlateToolbar/PlateToolbar.module.scss';

type Alignment = 'left' | 'center' | 'right' | 'justify';

// Use a generic component type for `Icon` instead of `typeof FormatAlignLeftIcon`.
// The latter trips Babel's preset-typescript: the import is used as a value
// (in the OPTIONS array) AND a type annotation, and Babel can't tell which
// to strip ("Cannot transform the imported binding since it's also used in
// a type annotation"). Same fix as PlateToolbar.tsx.
const OPTIONS: Array<{ value: Alignment; label: string; Icon: React.ComponentType<{ fontSize?: 'small' | 'medium' | 'large' }> }> = [
    { value: 'left', label: 'Align left', Icon: FormatAlignLeftIcon },
    { value: 'center', label: 'Align center', Icon: FormatAlignCenterIcon },
    { value: 'right', label: 'Align right', Icon: FormatAlignRightIcon },
    { value: 'justify', label: 'Justify', Icon: FormatAlignJustifyIcon },
];

export function AlignMenu() {
    const editor = useEditorRef();
    // Library hook: reads the `align` prop across the current selection
    // fragment, returns the value if uniform, otherwise undefined.
    // Replaces the hand-rolled useEditorSelector + block({ block: true }) ladder.
    const current: Alignment | undefined =
        ((useSelectionFragmentProp as any)({
            defaultValue: 'left',
            getProp: (node: any) => node?.align,
        }) as Alignment | undefined) ?? 'left';

    return (
        <>
            {OPTIONS.map(({ value, label, Icon }) => (
                <button
                    key={value}
                    type="button"
                    className={clsx(toolbarStyles.btn, current === value && toolbarStyles.btnActive)}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        (setAlign as any)(editor, value);
                    }}
                    title={label}
                    aria-label={label}
                    aria-pressed={current === value || undefined}
                >
                    <Icon fontSize="small" />
                </button>
            ))}
        </>
    );
}
